<template>
  <tr class="table-row">
    <template v-for="(column, index) in columns">
      <!-- Action Cell -->
      <td
        v-if="column.key === 'actions'"
        :key="index"
        class="b2b-grid__cell lg:table-cell"
        :qaid="`warranty-grid-cell-${column.key}`"
      >
        <div class="b2b-grid__label">
          <slot name="label">
            <span v-html="column.label"></span>
          </slot>
        </div>
        <div class="b2b-grid__content">
          <slot>
            <div class="flex content-center justify-start">
              <a
                v-if="showEditAction"
                class="underline hover:no-underline mr-1"
                :href="warrantyClaimEditUrl"
                qaid="`warranty-grid-cell-edit"
              >
                <span>{{ getBaseProperty('edit') }}</span>
              </a>
              <a
                v-if="showViewAction"
                class="underline hover:no-underline mr-1"
                :href="warrantyClaimUrl"
                qaid="`warranty-grid-cell-view"
              >
                <span>{{ getBaseProperty('view') }}</span>
              </a>
              <div v-if="item.statusCode === 'enumClaimStatusSaved'" @click="$emit('delete-claim', item.id)">
                <grid-icon
                  :data="{value: 'delete', cssClass: 'cursor-pointer'}"
                  qaid="`warranty-grid-cell-delete"
                ></grid-icon>
              </div>
            </div>
          </slot>
        </div>
      </td>

      <!-- ID Cell -->
      <td
        v-else-if="column.key === 'id'"
        :key="index"
        class="b2b-grid__cell lg:table-cell"
        :qaid="`warranty-grid-cell-${column.key}`"
      >
        <div class="b2b-grid__label">
          <slot name="label">
            <span v-html="column.label"></span>
          </slot>
        </div>
        <div class="b2b-grid__content">
          <slot>
            <a class="underline hover:no-underline" :href="warrantyClaimUrl">
              <span v-html="item[column.key]"></span>
            </a>
          </slot>
        </div>
      </td>

      <!-- Order History Cell -->
      <template v-else-if="column.key === 'orderHistory'">
        <td :key="index" class="b2b-grid__cell lg:table-cell" :qaid="`warranty-grid-cell-${column.key}`">
          <div class="b2b-grid__label">
            <slot name="label">
              <span v-html="column.label"></span>
            </slot>
          </div>
          <div class="b2b-grid__content">
            <slot>
              <a
                v-for="(order, orderIndex) in item.orderHistory"
                :key="orderIndex"
                class="underline hover:no-underline"
                :href="`${contextPath}${order.url}`"
                >{{ order.name }}</a
              >
            </slot>
          </div>
        </td>
      </template>

      <!--Details Cell -->
      <template v-else-if="column.key === 'details'">
        <td :key="index" class="b2b-grid__cell lg:table-cell" :qaid="`warranty-grid-cell-${column.key}`">
          <div class="b2b-grid__label">
            <slot name="label">
              <span v-html="column.label" />
            </slot>
          </div>
          <div class="b2b-grid__content">
            <slot>
              <div>
                <a
                  v-if="item.orderHistory"
                  :href="warrantyDetailsUrl"
                  class="underline hover:no-underline"
                  qaid="warranty-grid-cell-details-link"
                >
                  <span v-html="getBaseProperty('view')" />
                </a>
              </div>
            </slot>
          </div>
        </td>
      </template>

      <!-- Plain Text Cell -->
      <grid-cell
        v-else
        :key="index"
        :label="column.label"
        :value="item[column.key]"
        :qaid="`warranty-grid-cell-${column.key}`"
      ></grid-cell>
    </template>
  </tr>
</template>

<script>
import GridCell from '@/components/grid/GridCell';
import GridIcon from '@/components/grid/GridIcon';

export default {
  components: {
    GridCell,
    GridIcon,
  },
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },

    columns: {
      type: Array,
      default: () => [],
    },

    item: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      contextPath: ACC.config.encodedContextPath || '',
    };
  },

  computed: {
    warrantyClaimUrl() {
      return `${this.contextPath}/warranty-claim/${this.item.id}`;
    },

    warrantyDetailsUrl() {
      return `${this.contextPath}/warranty-claim/details/${this.item.id}`;
    },

    warrantyClaimEditUrl() {
      return `${this.contextPath}/warranty-claim/edit/${this.item.id}`;
    },

    showEditAction() {
      return (
        this.item.statusCode === 'enumClaimStatusSaved' || this.item.statusCode === 'enumClaimStatusActionRequired'
      );
    },

    showViewAction() {
      return (
        this.item.statusCode === 'enumClaimStatusSubmitted' ||
        this.item.statusCode === 'enumClaimStatusCompleted' ||
        this.item.statusCode === 'enumClaimStatusCancelled'
      );
    },
  },
};
</script>
